type BadgeNavigator = Navigator & { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> };

/** The number on the installed app's icon (iOS 16.4+ / Chromium); silently ignored elsewhere. */
export function setAppBadge(unread: number) {
  const nav = navigator as BadgeNavigator;
  try {
    if (unread > 0) void nav.setAppBadge?.(unread).catch(() => undefined);
    else void nav.clearAppBadge?.().catch(() => undefined);
  } catch {
    /* not supported */
  }
}
